import { JQL_SEARCH, JIRA_CF_FIELDS, JIRA_ISSUE, JIRA_LICENSE, JIRA_PROJECT, JIRA_ISSUE_TYPE,JIRA_USER_INFO,JIRA_ADMIN_PERMISSION,APP_WEB_LOCATION_IN_JIRA } from "../actions/types";
const initialState = {
  jqlSearchResult: {},
  fields: [],
  issue: {},
  license: {},
  projects: [],
  issueTypes: [],
  jiraUser: {},
  adminPermission: {},
  currentUser: {}
};

export default function (state = initialState, action) {
  switch (action.type) {
    case JQL_SEARCH:
      return {
        ...state,
        jqlSearchResult: action.payload,
      };
    case JIRA_CF_FIELDS:
      return {
        ...state,
        fields: action.payload,
      };
    case JIRA_ISSUE:
      return {
        ...state,
        issue: action.payload,
      };
    case JIRA_LICENSE:
      return {
        ...state,
        license: action.payload,
      };
    case JIRA_PROJECT:
      return {
        ...state,
        projects: action.payload,
      };
    case JIRA_ISSUE_TYPE:
      return {
        ...state,
        issueTypes: action.payload,
      };
    case JIRA_USER_INFO:
        return {
          ...state,
          jiraUser: action.payload,
      };
   case JIRA_ADMIN_PERMISSION:
        return {
          ...state,
          adminPermission: action.payload,
      };
    case APP_WEB_LOCATION_IN_JIRA:
        return {
          ...state,
          appWebLocation: action.payload,
      };
    
    default:
      return state;
  }
}
